<template>
  <div class="dashboard-block" v-if="!booking.is_offer">
    <h2>
      {{ $starLabel }} Recommendations
    </h2>

    <div v-if="haveNoRecommendedTalent" class="text-center alert alert-default">
      There are no recommended {{ $starLabelPlural }}.
    </div>

    <ul v-else class="tags">
      <li v-for="talent in recommendations" :key="'current' + talent.id">
        <span v-if="isRecommended(talent)" style="color: #44bd6c">{{ talent.name }}</span>
        <span v-else>{{ talent.name }}</span>
      </li>
    </ul>

    <div class="form-item__row">
      <div class="form-item__field">
        <div class="input-group input-group-booking-detail" v-if="!$vlastMode">
          <span class="input-group-addon">Compare With Version:</span>
          <selectize
                  class="selectize selectize-single"
                  name="engine_version"
                  :disable-delete="true"
                  v-model="version"
                  :options="versions">
          </selectize>
        </div>
      </div>
    </div>

    <ul v-if="versionTalent" class="tags">
      <li v-for="talent in versionTalent" :key="'version' + talent.id">
        <span v-if="isRecommended(talent)" style="color: #44bd6c">{{ talent.name + ' ' + talent.score }}</span>
        <span v-else>{{ talent.name + ' ' + talent.score }}</span>
      </li>
    </ul>

  </div>
</template>

<script>
import { helpers } from 'mixins/bookings'
import Selectize from '../ext/codium/CodiumSelectize'
import { http, notify } from 'utils'

export default {
  mixins: [helpers],

  data () {
    return {
      version: '',
      versionTalent: null,
      versions: [
        {id: '1', text: 'Version 1'},
        {id: '2', text: 'Version 2'},
        {id: '3', text: 'Version 3'},
        {id: '4', text: 'Version 4'}
      ]
    }
  },

  props: {
    recommendations: {
      required: true,
      type: Array
    },
    booking: {
      required: true,
      type: Object
    }
  },

  components: {
    Selectize
  },

  computed: {
    haveNoRecommendedTalent () {
      return this.recommendations.length === 0
    }
  },

  watch: {
    version (value) {
      if (value === '') {
        this.versionTalent = null
        return
      }

      http.get('recommendations/' + this.booking.id + '/' + value)
        .then(response => {
          this.versionTalent = response.data
        })
        .catch(() => {
          this.versionTalent = null
          notify.error('Invalid version number.')
        })
    }
  },

  methods: {
    isRecommended (talent) {
      return this.booking.talent_notified && this.booking.talent_notified.length
        ? this.booking.talent_notified.concat(this.booking.talent).filter(talNotified => talNotified.id === talent.id).length !== 0
        : false
    }
  }
}
</script>
